import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Cookies from "js-cookie";
import { useForm, Controller } from "react-hook-form";
import { countryCode, CountryList } from "../../apis/api/CountryList";
import { MemberInsert } from "../../apis/api/MemberApi";
import Lodderr from "../../components/Lodder/Lodder";
import { toast } from "react-toastify";


const AddMember = ({ show, onHide, data }) => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);
  const access = JSON.parse(Cookies.get("access"));

  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const countryCodeData = useSelector((state) => state.countrySlice);
  const countryCodeOptions = countryCodeData?.countryCode?.data?.data || [];
  const { country } = useSelector((state) => state.countrySlice);
  const { loading } = useSelector((state) => state.MemberSlice);
  const titleOptions = ["Mr", "Mrs", "Ms"].map((t) => ({ label: t, value: t }));

  const handleCloseModal = () => {
    reset();
    setPreview(null);
    onHide();
  };

  useEffect(() => {
    dispatch(countryCode());
    dispatch(CountryList());
  }, [dispatch]);

  useEffect(() => {
    if (data && country?.length) {
      reset({
        Title: { label: data.salutation, value: data.salutation },
        FirstName: data.first_name || "",
        MiddleName: data.middle_name || "",
        LastName: data.last_name || "",
        JobTitle: data.job_title || "",
        Department: data.department || "",
        PhoneDirect: data.contact || "",
        Email: data.email || "",
        CountryCode:
          countryCodeOptions.find((code) => code.value === data.country_code) ||
          null,
        Access: data.access || "",
        ProfilePicture: data.member_logo || null,
        Country: country.find((c) => c.label === data.location) || null,
      });
      setPreview(
        typeof data.member_logo === "string"
          ? data.member_logo
          : data.member_logo instanceof File
          ? URL.createObjectURL(data.member_logo)
          : null
      );
    }
  }, [data, reset, country, countryCodeOptions]);

  const onSubmit = async(formData) => {
    const company_id = Cookies.get("company_id");
    const payload = new FormData();

    const fieldTransform = {
      Title: (val) => val?.value || "",
      CountryCode: (val) => val?.value || "",
      Country: (val) => val?.label || "",
      ProfilePicture: (val) => val,
      Access: (val) => val || "",
    };

    for (const key in formData) {
      let value = formData[key];
      if (fieldTransform[key]) {
        value = fieldTransform[key](value);
      }
      if (key === "ProfilePicture") {
        if (value instanceof File) {
          payload.append(key, value);
        }
      } else {
        payload.append(key, value || "");
      }
    }
    if(access.extra_contact === "1")
      payload.append("contactLimit", access.extra_contact_limit);
    payload.append("company_id", company_id || "");

  const response =await dispatch(MemberInsert(payload));
  if(response.payload.status == "success"){
    toast.success("Member added successfully. Please contact the admin for approval.");

  }else{
    toast.error(response.payload.data.message || "Error in form submission.");
  }
  
    handleCloseModal();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      setValue("ProfilePicture", file, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <>
      {loading && <Lodderr />}
      <Modal show={show} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-semibold text-dark">Add Member</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light px-4 py-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4">
              <div className="col-md-12">
                <label className="form-label fw-bold">Profile Picture *</label>
                <div
                  className="d-flex flex-column align-items-center justify-content-center border border-2 border-dashed rounded-3 p-4 bg-white"
                  style={{ cursor: "pointer" }}
                  onClick={() => document.getElementById("member-logo-upload").click()}
                >
                  <input
                    type="file"
                    id="member-logo-upload"
                    accept="image/*"
                    className="d-none"
                    onChange={handleFileChange}
                  />
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      className="rounded-circle shadow"
                      style={{ width: "150px", height: "150px", objectFit: "cover" }}
                    />
                  ) : (
                    <>
                      <i className="fas fa-upload fs-2 text-muted mb-2"></i>
                      <span className="text-muted">Click or drag file to upload</span>
                    </>
                  )}
                </div>
                {errors.ProfilePicture && (
                  <p className="text-danger">{errors.ProfilePicture.message}</p>
                )}
              </div>

              <div className="col-md-12">
                <label className="form-label fw-bold">Title*</label>
                <Controller
                  name="Title"
                  control={control}
                  rules={{ required: "Title is required" }}
                  render={({ field }) => (
                    <Select {...field} options={titleOptions} placeholder="Select Title" />
                  )}
                />
                {errors.Title && <p className="text-danger">{errors.Title.message}</p>}
              </div>

              {["FirstName", "MiddleName", "LastName"].map((field) => (
                <div className="col-md-4" key={field}>
                  <label className="form-label fw-bold">{field.replace("Name", " Name *")}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={
                      field === "FirstName" ? "John" : field === "MiddleName" ? "M." : "Doe"
                    }
                    {...register(field, {
                      required:
                        field !== "MiddleName"
                          ? `${field.replace("Name", " name")} is required`
                          : false,
                    })}
                  />
                  {errors[field] && <p className="text-danger">{errors[field].message}</p>}
                </div>
              ))}

              <div className="col-md-6">
                <label className="form-label fw-bold">Job Title*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter job Title here"
                  {...register("JobTitle", { required: "Job title is required" })}
                />
                {errors.JobTitle && <p className="text-danger">{errors.JobTitle.message}</p>}
              </div>

              <div className="col-md-6">
                <label className="form-label fw-bold">Department*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter department"
                  {...register("Department", { required: "Department is required" })}
                />
                {errors.Department && <p className="text-danger">{errors.Department.message}</p>}
              </div>

              <div className="col-md-12">
                <label className="form-label fw-bold">Email*</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  {...register("Email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter a valid email address",
                    },
                  })}
                />
                {errors.Email && <p className="text-danger">{errors.Email.message}</p>}
              </div>

              <div className="col-md-12">
                <label className="form-label fw-bold">Phone Number*</label>
                <div className="d-flex gap-2">
                  <Controller
                    name="CountryCode"
                    control={control}
                    rules={{ required: "Country code is required" }}
                    render={({ field }) => (
                      <Select {...field} className="w-25" options={countryCodeOptions} placeholder="Code" />
                    )}
                  />
                  <input
                    type="text"
                    className="form-control w-75"
                    {...register("PhoneDirect", { required: "Phone number is required" })}
                  />
                </div>
                {errors.CountryCode && <p className="text-danger">{errors.CountryCode.message}</p>}
                {errors.PhoneDirect && <p className="text-danger">{errors.PhoneDirect.message}</p>}
              </div>

              <div className="col-md-12">
                <label className="form-label fw-bold">Country*</label>
                <Controller
                  name="Country"
                  control={control}
                  rules={{ required: "Country is required" }}
                  render={({ field }) => (
                    <Select {...field} options={country} placeholder="Select Country" isClearable />
                  )}
                />
                {errors.Country && <p className="text-danger">{errors.Country.message}</p>}
              </div>

              <div className="col-md-12">
                <label className="form-label fw-bold">Access*</label>
                <Controller
                  name="Access"
                  control={control}
                  rules={{ required: "Access type is required" }}
                  render={({ field }) => (
                    <>
                      <div className="form-check form-check-inline ms-3">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="admin"
                          value="0"
                          checked={field.value === "Admin"}
                          onChange={field.onChange}
                        />
                        <label className="form-check-label" htmlFor="admin">Admin</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="member"
                          value="1"
                          checked={field.value === "Member"}
                          onChange={field.onChange}
                        />
                        <label className="form-check-label" htmlFor="member">Member</label>
                      </div>
                    </>
                  )}
                />
                {errors.Access && <p className="text-danger">{errors.Access.message}</p>}
              </div>

              <div className="col-12 text-end">
                <button type="submit" className="btn btn-secondary px-4 shadow-sm">Add Member</button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddMember;